import React from 'react';

import {IssuesContextProvider} from '../../state/issues/IssuesContext';
import {
  getDataChecked,
  getError,
  getStatus,
} from '../../state/workspaces/selectors';
import {useDetectChanges} from '../../util/react-help/detectReactPropChanges';
import {SharedPanelZoomContextProvider} from '../PanelRunsLinePlot/SharedPanelZoomContext';
import {useMultiRunWorkspaceProps} from '../Workspace/multiRunWorkspaceHooks';
import {WorkspaceErrorBoundary} from '../Workspace/WorkspaceErrorBoundary';
import {WorkspaceErrorContent} from '../Workspace/WorkspaceErrorContent';
import {WorkspaceRefsContextProvider} from '../Workspace/WorkspaceRefsContext';
import {SemanticLegendSettingsContextProvider} from '../WorkspaceDrawer/Settings/semanticLegend/SemanticLegendSettingsContextProvider';
import {WorkspaceSettingsContextProvider} from '../WorkspaceDrawer/Settings/WorkspaceSettingsContextProvider';
import {LoaderProxy} from './../../containers/AppLoader';
import {KeyInfoQueryContextProvider} from './KeyInfoQueryContext';
import {MultiRunWorkspace} from './MultiRunWorkspace';
import {SingleRunModeContextProvider} from './SingleRunMode';
import {MultiRunWorkspaceWorkspaceProps} from './types';

const clearSetting = () => {};
const settingLevel = 'workspace';
const settingOverrideCounts = {};
const trackSemanticLegendSettings = () => {};

export const MultiRunWorkspaceWorkspace = (
  props: MultiRunWorkspaceWorkspaceProps
) => {
  const multiRunWorkspaceProps = useMultiRunWorkspaceProps(props);
  useDetectChanges('MultiRunWorkspaceWorkspace', props as Record<string, any>);

  if (getStatus(multiRunWorkspaceProps) === 'error') {
    return (
      <WorkspaceErrorContent
        error={getError(multiRunWorkspaceProps)}
        viewType={props.viewType}
      />
    );
  }
  if (getStatus(multiRunWorkspaceProps) === 'loading') {
    return <LoaderProxy name="multi-run-workspace" />;
  }
  const data = getDataChecked(multiRunWorkspaceProps);

  return (
    <WorkspaceErrorBoundary
      workspaceStateId={data.workspaceID}
      viewType={props.viewType}>
      <SingleRunModeContextProvider>
        <IssuesContextProvider workspaceType={props.viewType}>
          <KeyInfoQueryContextProvider
            entityName={props.entityName}
            runSetRefs={data.sectionPart.runSetRefs}
            customRunNamesRef={data.sectionPart.customRunNamesRef}>
            <WorkspaceRefsContextProvider
              customRunColorsRef={data.sectionPart.customRunColorsRef}
              customRunNamesRef={data.sectionPart.customRunNamesRef}
              panelBankConfigRef={data.panelBankConfigRef}
              viewRef={data.partRef}
              workspaceSettingsRef={data.sectionPart.workspaceSettingsRef}>
              <WorkspaceSettingsContextProvider>
                <SemanticLegendSettingsContextProvider
                  clearSetting={clearSetting}
                  runsetRef={data.runSetRef}
                  settingLevel={settingLevel}
                  settingOverrideCounts={settingOverrideCounts}
                  trackSemanticLegendSettings={trackSemanticLegendSettings}>
                  <SharedPanelZoomContextProvider>
                    <MultiRunWorkspace {...props} {...data} />
                  </SharedPanelZoomContextProvider>
                </SemanticLegendSettingsContextProvider>
              </WorkspaceSettingsContextProvider>
            </WorkspaceRefsContextProvider>
          </KeyInfoQueryContextProvider>
        </IssuesContextProvider>
      </SingleRunModeContextProvider>
    </WorkspaceErrorBoundary>
  );
};
